import { NX_MESSAGE_TOAST_COMPONENT_DATA } from '@allianz/ng-aquila/message';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-toast-message',
  imports: [
    TranslocoPipe,
  ],
  templateUrl: './toast-message.component.html',
  styleUrl: './toast-message.component.scss',
})
export class ToastMessageComponent {
  data = inject(NX_MESSAGE_TOAST_COMPONENT_DATA);
}
